var envelope = "https://shopfront-cdn.tekoapis.com/static/a66400b1ee8416d3.svg";

export { envelope as default };
